import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function MainLayout({ children }) {
  return (
    <div className="min-h-screen bg-white">
      {/* Replace old navigation with Navbar component */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <Navbar />
      </div>
      
      {/* Add padding to prevent content from hiding under fixed navbar */}
      <div className="pt-20">
        {/* Main Content */}
        <main>{children}</main>
      </div>

      <Footer />
    </div>
  );
}

export default MainLayout;